// Copyright (c) 2017 Deere & Company

const compareAsc = (a, b) => {

    if (a < b) {

        return -1;

    } else if (a > b) {

        return 1;

    }

    return 0;

};

export const sortCollection = (sortBy, direction, collection) => {

    const collectionToSort = [...collection];

    if (sortBy[0] === 'isShipmentPriorityHigh') {

        collectionToSort.sort((a, b) => {

            const sortedList = compareAsc(a.isShipmentPriorityHigh, b.isShipmentPriorityHigh) || compareAsc(b.daysLeft, a.daysLeft);

            if (direction === 'DESC') {

                return sortedList * -1;

            }

            return sortedList;

        });

    } else {

        collectionToSort.sort((a, b) => {

            let nestedA,
                nestedB;

            nestedA = a;
            nestedB = b;

            sortBy.forEach(key => {

                if (key.slice(-2) === '()') {

                    const functionName = key.slice(0, -2);

                    nestedA = nestedA[functionName]();
                    nestedB = nestedB[functionName]();

                } else {

                    nestedA = nestedA[key];
                    nestedB = nestedB[key];

                }

            });

            const result = compareAsc(nestedA, nestedB);

            if (direction === 'DESC') {

                return result * -1;

            }

            return result;

        });

    }

    return collectionToSort;

};

export const filterCollection = (filterString, filterOptions, collection) => {

    if (filterString !== '') {

        return collection.filter(element => {

            const keys = filterOptions.map(path => {

                let nestedProps;

                nestedProps = element;

                path.forEach(key => {

                    nestedProps = nestedProps ? nestedProps[key] : null;

                });

                return nestedProps;

            });

            return keys.find(item => String(item).toLowerCase().includes(filterString.toLowerCase()));

        });

    }

    return collection;

};

export const getCollectionLength = collection => {

    const sortedCollection = collection.reduce((map, obj) => {

        map[obj.requestId] = obj;
        return map;

    }, {});

    return Object.keys(sortedCollection).length;

};



// WEBPACK FOOTER //
// ./src/shared/services/collections.js